/**
 * Created by Bezsmertnyi Ievgen on 12.09.2020.
 */

const getTranslateFunc = function () {
  let i18n;

  try {
    i18n = require('@/lang/i18n.js').default;
  } catch (error) {
    // console.log(error);
  }

  return i18n
    ? (translateAlias) => i18n.t(translateAlias)
    : (translateAlias) => translateAlias;
};

const getTranslate = getTranslateFunc();

//Должен называться так же как и в modules_components_obj
let module_name = 'Polls';

let module_settings = {
  module_name,
};
//Корневой урл модуля
let module_alias = 'polls';

//Полный список разрешений модуля
module_settings.permits = {
  front: {
    //Отображение пунктов меню
    registered_users_show_menu_item: {
      description: 'Отображать в меню пункт зарегистрированных пользователей',
    },
    //Отображение табов
    registered_users_show_messengers_tab_item: {
      description:
        'Отображать таб мессенджеров зарегистрированных пользователей',
    },
  },

  back: {},
};

//Пункты в меню
module_settings.menu_items = [
  {
    title: getTranslate('modules.polls.module_settings.poll'),
    module: module_name,
    alias: module_alias,
    icon: 'mdi-poll',
    permits: {
      show: 'polls_show_menu_item',
    },
    show: true,
    route: 'polls',
  },
];

//Табы модуля
module_settings.tabs_items = {};

module_settings.tabs_items[module_name] = {
  use_tabs: true,
  tabs_items: [
    {
      tab: getTranslate('modules.polls.module_settings.polls'),
      content: '',
      show: true,
      type: 'polls',
      alias: '/',
      permits: {
        show: 'registered_users_show_messengers_tab_item',
      },
      route: 'section',
    },
  ],
};

//Подключенные компоненты
module_settings.components = [
  {
    name: module_name,
    path: 'Component/Polls.vue',
  },
];

//Экспорт для vue и для node
module.exports = { module_settings };
module.exports.default = { module_settings };
